import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'caseGroupCreationMedcodesPipe',
  pure: true
})
export class CaseGroupCreationMedcodesPipePipe implements PipeTransform {

  transform(codesData: any[], searchTermmed: string): any[]  {
    if (!codesData || !searchTermmed) { return codesData; }
    return codesData.filter(ad =>
     
    
      ad.name.toLowerCase().indexOf(searchTermmed.toLowerCase().trim()) !== -1



    );
  }

}
